import { render, staticRenderFns } from "./UserTeamsEditForm.vue?vue&type=template&id=71012655&scoped=true&"
import script from "./UserTeamsEditForm.vue?vue&type=script&lang=js&"
export * from "./UserTeamsEditForm.vue?vue&type=script&lang=js&"
import style0 from "./UserTeamsEditForm.vue?vue&type=style&index=0&id=71012655&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71012655",
  null
  
)

export default component.exports